function waitForTrack(selector, callback) {
  const el = document.querySelector(selector);
  if (el) return callback(el);

  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

waitForTrack("#nrpCarouselTrack", (track) => {
  const cardWidth = 300 + 24; // 300 + 2x12px margin
  let index = 0;
  let autoSlideInterval;

  function setupCarousel() {
      const totalCards = track.childElementCount;
      let resetPoint = 4;

      if (totalCards === 8 || totalCards === 6) {
          resetPoint = 4;
      } else if (totalCards === 9) {
          resetPoint = 3;
      }

      // Start sliding
      index = 0;
      clearInterval(autoSlideInterval);

      autoSlideInterval = setInterval(() => {
          index++;
          track.style.transition = 'transform 0.5s ease-in-out';
          track.style.transform = `translateX(-${index * cardWidth}px)`;

          // When reaching the end of the loop, jump back to start
          if (index >= resetPoint) {
          setTimeout(() => {
              track.style.transition = 'none';
              index = 0;
              track.style.transform = 'translateX(0px)';
          }, 500); // Wait for transition to finish
          }
      }, 3000);
  }

  setupCarousel();
});

waitForTrack("#nrpCarouselTrackDesktop", (track) => {
  const cardWidth = 300 + 24; // 300 + 2x12px margin
  let index = 0;
  let autoSlideInterval;

  function setupCarousel() {
      const totalCards = track.childElementCount;
      let resetPoint = 4;

      if (totalCards === 8 || totalCards === 6) {
          resetPoint = 4;
      } else if (totalCards === 9) {
          resetPoint = 3;
      }

      // Start sliding
      index = 0;
      clearInterval(autoSlideInterval);

      autoSlideInterval = setInterval(() => {
          index++;
          track.style.transition = 'transform 0.5s ease-in-out';
          track.style.transform = `translateX(-${index * cardWidth}px)`;

          // When reaching the end of the loop, jump back to start
          if (index >= resetPoint) {
          setTimeout(() => {
              track.style.transition = 'none';
              index = 0;
              track.style.transform = 'translateX(0px)';
          }, 500); // Wait for transition to finish
          }
      }, 3000);
  }

  setupCarousel();
});